<template>
  <div class="searchContainer relative" :class="id">
    <label v-if="label" class="block mb-2">{{ label }}</label>
    <div class="relative PC_Body2-R ">
      <input
        type="search"
        :placeholder="placeholder"
        v-model="searchTerm"
        class="h-[42px] w-full py-2 pl-3 pr-10 bg-white border border-grey-light rounded-[6px] PC_Body2-R placeholder-grey-light focus:outline-none focus:ring-0 focus:border-[#B7B2B5]"
        @input="handleSearch"
      />
      <div class="absolute inset-y-0 end-0 flex items-center pr-3 pointer-events-none">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M11.797 2.57361C9.25432 0.0309637 5.11597 0.0309637 2.57332 2.57361C0.0312238 5.11681 0.0312238 9.25461 2.57332 11.7978C4.83762 14.0616 8.36414 14.3041 10.9051 12.5364C10.9586 12.7894 11.081 13.0308 11.2777 13.2276L14.9807 16.9305C15.5203 17.469 16.3923 17.469 16.9291 16.9305C17.4682 16.3914 17.4682 15.5195 16.9291 14.982L13.2262 11.278C13.0305 11.0829 12.7886 10.96 12.5356 10.9065C14.3043 8.36499 14.0618 4.83901 11.797 2.57361ZM10.6279 10.6287C8.72958 12.527 5.64015 12.527 3.7424 10.6287C1.8452 8.73043 1.8452 5.64155 3.7424 3.74324C5.64015 1.84549 8.72958 1.84549 10.6279 3.74324C12.5262 5.64155 12.5262 8.73043 10.6279 10.6287Z"
            fill="#320B3C"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBox",

  props: {
    id: {
      required: true,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "ค้นหา...",
    },
    modelValue: {
      type: String,
      default: "",
    },
  },

  emits: ["update:modelValue", "search"],

  data() {
    return {
      searchTerm: this.modelValue || "",
    };
  },

  watch: {
    modelValue(newValue) {
      this.searchTerm = newValue;
    },
  },

  methods: {
    handleSearch() {
      this.$emit("search", this.searchTerm);
      this.$emit("update:modelValue", this.searchTerm);
    },
  },
};
</script>

<style scoped>
/* No additional styles needed */
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
  appearance: none;
  display: none;
}

input::placeholder {
  color: #B7B2B5;
}
</style>
